import { Quote } from "lucide-react";

import { TestimonialCardProps } from "../types";
import BaseDivider from "@/components_v2/Divider/BaseDivider";

const TestimonialCard = ({
  stepNumber,
  title,
  description,
  attribution,
}: TestimonialCardProps) => {
  return (
    <article className="guidance-page-testimonial-card flex flex-col gap-300">
      <div className="guidance-page-testimonial-card-content flex flex-col gap-300 flex-1 min-h-0">
        <div className="flex items-start justify-between gap-200">
          <span
            className="guidance-page-testimonial-card-badge flex items-center justify-center body-s-medium"
            aria-hidden
          >
            {stepNumber}
          </span>

          <Quote
            size={32}
            className="guidance-page-testimonial-card-quote-icon flex-shrink-0"
            aria-hidden
          />
        </div>

        <h3 className="guidance-page-testimonial-card-title body-m-medium">
          {title}
        </h3>

        <p className="guidance-page-testimonial-card-description body-m-regular">
          {description}
        </p>
      </div>

      <div className="guidance-page-testimonial-card-footer flex flex-col gap-300">
        <BaseDivider />

        <p className="guidance-page-testimonial-card-attribution body-s-regular">
          {attribution}
        </p>
      </div>
    </article>
  );
};

export default TestimonialCard;
